// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"251":"56d0e363","453":"7d13bba2","963":"56efa78a"}[chunkId] + ".chunk.js";
};